export const employeeLocaleToBryntumLocale = (locale: string) => {
  const bryntumLocaleMap: Record<string, string> = {
    // English
    en: 'EnGb',
    'en-us': 'En',
    // German
    de: 'De',
    'de-ch': 'De',
    // French
    fr: 'FrFr',
    // Italian
    it: 'It',
    // Spanish
    es: 'Es',
    // Russian
    ru: 'Ru',
    // Norwegian
    no: 'No',
    // Portuguese
    pt: 'Pt',
  };

  return bryntumLocaleMap[locale] || 'En';
};
